<template>
  <div>
    <new-category :form_id="form.id" @created="getCategories(true)" />

    <modify-category
      :form_id="form.id"
      :category_id="current_category_id"
      :editable="form.status_value == 'OPEN'"
      @updated="getCategories"
    />

    <new-question
      :form_id="form.id"
      :category_id="current_category_id"
      @created="getCategories"
    />

    <modify-question
      :form_id="form.id"
      :category_id="current_category_id"
      :question_id="current_question_id"
      :editable="form.status_value == 'OPEN'"
      @updated="getCategories"
    />

    <div>
      <div class="row">
        <div
          class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 check-text-center"
        >
          <h4 class="my-0">CATEGORIA E PERGUNTA</h4>
        </div>

        <div
          class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 check-text-right"
        >
          <!-- entrar e salvar reordernação -->
          <v-btn
            class="btn-reordenar-save m-1"
            v-show="
              form.status_value == 'OPEN' && !reorder_mode && allowReorderMode()
            "
            @click.stop="reorderMode"
          >
            <i class="fas fa-sort text-twenty mr-2"></i> REORDENAR
          </v-btn>

          <v-btn
            v-show="form.status_value == 'OPEN' && !reorder_mode"
            class="btn-add ml-2"
            @click.prevent="$bvModal.show('new_category')"
          >
            <i class="fas fa-plus text-twenty mr-2" /> NOVA CATEGORIA
          </v-btn>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <v-expansion-panels mandatory accordion hover class="border">
            <v-expansion-panel
              v-for="(category, category_index) in categories"
              :key="category.id"
            >
              <v-expansion-panel-header>
                <div class="row align-items-center">
                  <div class="col-12 d-flex justify-content-between">
                    <h6 class="upper-text worksansr pt-1 mb-0">
                      CATEGORIA:
                      <strong class="upper-text">{{ category.name }}</strong>
                    </h6>

                    <h6 class="upper-text worksansr pt-1 mb-0 text-end">
                      <div v-if="category.public == 1">
                        <strong class="badge badge-success">Pública</strong>
                      </div>

                      <div v-else>
                        <strong class="badge badge-danger">Privada</strong>
                      </div>

                      <div v-if="category.required_certificate == 1">
                        <strong class="badge badge-warning">
                          <i class="fas fa-signature"></i>
                          Obrigatoriedade de assinatura com certificado!
                        </strong>
                      </div>
                    </h6>
                  </div>

                  <div
                    class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 check-text-right"
                  >
                    <v-btn
                      v-show="
                        form.status_value == 'OPEN' &&
                        reorder_mode &&
                        category_index > 0
                      "
                      class="btn-reordenar mr-5"
                      small
                      :disabled="loading"
                      @click.stop="reorderCategory(category_index, -1)"
                    >
                      <i class="fas fa-arrow-up text-thirteen"></i>
                    </v-btn>

                    <v-btn
                      v-show="
                        form.status_value == 'OPEN' &&
                        reorder_mode &&
                        category_index < categories.length - 1
                      "
                      class="btn-reordenar mr-5"
                      small
                      :disabled="loading"
                      @click.stop="reorderCategory(category_index, 1)"
                    >
                      <i class="fas fa-arrow-down text-thirteen"></i>
                    </v-btn>

                    <confirmation-dialog
                      v-show="form.status_value == 'OPEN' && !reorder_mode"
                      :disabled="loading"
                      small
                      message-title="Confirmar"
                      message-body="Tem certeza que deseja remover esta categoria?"
                      open-text="EXCLUIR"
                      open-class="btn-delete m-1"
                      yes-class="btn-delete"
                      open-left-icon="fa-trash mr-2"
                      @yes="removeCategory(category.id)"
                    />

                    <v-btn
                      v-show="form.status_value == 'OPEN' && !reorder_mode"
                      class="btn-edit m-1"
                      small
                      @click.stop="openModifyCategory(category.id)"
                    >
                      <i class="fas fa-pencil-alt mr-2 text-twenty" />
                      EDITAR
                    </v-btn>

                    <v-btn
                      v-show="form.status_value == 'OPEN' && !reorder_mode"
                      class="btn-two-add m-1"
                      small
                      @click.stop="openNewQuestion(category.id)"
                    >
                      <i class="fas fa-plus mr-2 text-twenty"></i>
                      ADICIONAR PERGUNTA
                    </v-btn>
                  </div>
                </div>
              </v-expansion-panel-header>

              <v-expansion-panel-content class="p-0">
                <errors-messages :errors="errors" />

                <h6 class="back-ground-grey p-2 upper-text">Perguntas:</h6>

                <v-expansion-panels accordion flat hover class="p-0">
                  <v-expansion-panel
                    v-for="(question, question_index) in category.questions"
                    :key="question.id"
                    class="p-0"
                  >
                    <v-expansion-panel-header>
                      <div class="row">
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                          <h6>
                            {{ question_index + 1 }}. {{ question.statement }}
                          </h6>

                          <div
                            class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0"
                          >
                            <div class="row">
                              <h6
                                class="color-blue text-twelve mr-3 border p-1"
                              >
                                {{ question.type_name }}
                              </h6>

                              <h6
                                v-show="question.mandatory"
                                class="color-red text-twelve border p-1"
                              >
                                OBRIGATÓRIA
                              </h6>
                            </div>

                            <div v-if="category.public == 0" class="mt-2">
                              <span
                                class="worksansr font-weight-bold text-secondary mb-1 d-block"
                              >
                                Perfis vinculados:
                              </span>

                              <div class="d-flex flex-wrap gap-2 mt-1">
                                <span
                                  v-for="profile_name in category.linked_profile_name"
                                  :key="profile_name"
                                  class="badge bg-primary text-white me-2 mb-1"
                                >
                                  {{ profile_name }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 check-text-right mt-4"
                        >
                          <v-btn
                            v-show="
                              form.status_value == 'OPEN' &&
                              reorder_mode &&
                              question_index > 0
                            "
                            class="btn-reordenar mr-5"
                            small
                            :disabled="loading"
                            @click.stop="
                              reorderQuestion(
                                category_index,
                                question_index,
                                -1
                              )
                            "
                          >
                            <i class="fas fa-arrow-up text-thirteen"></i>
                          </v-btn>

                          <v-btn
                            v-show="
                              form.status_value == 'OPEN' &&
                              reorder_mode &&
                              question_index < category.questions.length - 1
                            "
                            class="btn-reordenar mr-5"
                            small
                            :disabled="loading"
                            @click.stop="
                              reorderQuestion(category_index, question_index, 1)
                            "
                          >
                            <i class="fas fa-arrow-down text-thirteen"></i>
                          </v-btn>

                          <v-btn
                            v-show="
                              form.status_value == 'OPEN' && !reorder_mode
                            "
                            class="btn-edit mr-1"
                            small
                            @click.stop="
                              openModifyQuestion(category.id, question.id)
                            "
                          >
                            <i class="fas fa-pencil-alt mr-2 text-twenty"></i>
                            EDITAR
                          </v-btn>

                          <confirmation-dialog
                            v-show="
                              form.status_value == 'OPEN' && !reorder_mode
                            "
                            :disabled="loading"
                            small
                            message-title="Confirmar"
                            message-body="Tem certeza que deseja remover esta pergunta?"
                            open-text="EXCLUIR"
                            open-class="btn-delete mr-2"
                            open-left-icon="fa-trash mr-2"
                            @yes="removeQuestion(category.id, question.id)"
                          />

                          <div
                            class="switch-container"
                            v-show="form.status_value != 'OPEN'"
                          >
                            <span
                              class="worksansr font-weight-bold text-secondary mb-1 d-block"
                              >Copiar resposta no próximo formulário:
                            </span>

                            <label class="switch-modern">
                              <input
                                type="checkbox"
                                v-model="question.copy_answer_next_form"
                                :disabled="loading"
                                @change="
                                  updateDuplicateAnswer(
                                    question.id,
                                    question.copy_answer_next_form
                                  )
                                "
                              />

                              <span class="slider-modern">
                                <span class="slider-thumb">
                                  <i class="fas fa-check thumb-icon"></i>
                                </span>
                              </span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </v-expansion-panel-header>

                    <v-expansion-panel-content>
                      <template v-if="question.type_value != 'OPEN'">
                        <h6 class="mt-1">ALTERNATIVAS:</h6>

                        <div
                          v-for="(
                            alternative, alternative_index
                          ) in question.alternatives"
                          :key="alternative.id"
                          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0 pt-0"
                        >
                          <div class="row">
                            <div
                              class="col-xl-10 col-lg-10 col-md-10 col-sm-8 col-12 pb-0 pt-0"
                            >
                              <ul class="m-0">
                                <li class="mt-3">
                                  {{ alternative.label }}
                                </li>
                              </ul>
                            </div>
                            <div
                              class="col-xl-2 col-lg-2 col-md-2 col-sm-4 col-12 pb-0 pt-0 text-right"
                            >
                              <v-btn
                                v-show="
                                  form.status_value == 'OPEN' &&
                                  reorder_mode &&
                                  alternative_index > 0
                                "
                                class="btn-reordenar m-2"
                                small
                                :disabled="loading"
                                @click.stop="
                                  reorderAlternative(
                                    category_index,
                                    question_index,
                                    alternative_index,
                                    -1
                                  )
                                "
                              >
                                <i class="fas fa-arrow-up text-thirteen"></i>
                              </v-btn>

                              <v-btn
                                v-show="
                                  form.status_value == 'OPEN' &&
                                  reorder_mode &&
                                  alternative_index <
                                    question.alternatives.length - 1
                                "
                                class="btn-reordenar m-2"
                                small
                                :disabled="loading"
                                @click.stop="
                                  reorderAlternative(
                                    category_index,
                                    question_index,
                                    alternative_index,
                                    1
                                  )
                                "
                              >
                                <i class="fas fa-arrow-down text-thirteen"></i>
                              </v-btn>
                            </div>
                          </div>

                          <hr class="mt-1 mb-0" />
                        </div>
                      </template>

                      <template v-if="question.type_value == 'OPEN'">
                        <h6 class="worksansr pt-5 text-thirteen upper-text">
                          As perguntas abertas são aquelas que permitem qualquer
                          tipo de resposta. Elas não delimitam ou restrigem a
                          opções.
                        </h6>
                      </template>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </div>

      <b-row align-h="end">
        <b-col cols="auto">
          <v-btn
            class="btn-cancel m-1"
            v-show="form.status_value == 'OPEN' && reorder_mode"
            @click.stop="reorderCancel"
          >
            CANCELAR
          </v-btn>

          <v-btn
            class="btn-reordenar-save m-1"
            v-show="form.status_value == 'OPEN' && reorder_mode"
            @click.stop="reorderSave"
          >
            <i class="fas fa-sort text-twenty mr-2"></i> SALVAR
          </v-btn>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import api from "../../services/api";
import NewCategory from "./NewCategory";
import ModifyCategory from "./ModifyCategory";
import NewQuestion from "./NewQuestion";
import ModifyQuestion from "./ModifyQuestion";
import toast from "../../lib/ToastNotification";
import ErrorsMessages from "../Components/ErrorsMessages";
import ConfirmationDialog from "../Components/ConfirmationDialog";
import { arraySwapItemPosition } from "../../lib/functions";

export default {
  name: "Categories",
  components: {
    NewCategory,
    ModifyCategory,
    NewQuestion,
    ModifyQuestion,
    ErrorsMessages,
    ConfirmationDialog,
  },
  props: {
    /** @type {{
     *  name: string,
     *  description: string,
     *  rest_home_id: number,
     *  id: number,
     *  semiology_form_status_id: number,
     *  status_name: ("ABERTO"|"DISPONÍVEL"|"DESATIVADO"),
     *  status_value: ("OPEN"|"AVAILABLE"|"INACTIVE"),
     *  created_at: Date,
     *  updated_at: Date,
     *  profiles: { id: number, name: string }[],
     *  residents: { id: number, name: string }[],
     *}} formulário
     */
    form: Object,
  },
  data() {
    return {
      errors: [],

      categories: [],

      copy_answer_next_form: false,

      loading: false,

      reorder_mode: false,

      current_category_id: null,

      current_question_id: null,

      current_alternative_id: null,

      current_category_index: 0,
    };
  },
  watch: {
    form: function (form) {
      if (form.id) this.getCategories();
    },
  },

  methods: {
    async getCategories(openLastCategory = false) {
      try {
        this.loading = true;

        const params = { form_id: this.form.id };
        const response = await api.get("/rest-home/semiology/form/categories", {
          params,
        });
        const { error, errors, categories } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.categories = categories;
          if (openLastCategory) {
            setTimeout(() => {
              this.current_category_index = this.categories.length - 1;
            }, 100);
          }
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async updateDuplicateAnswer(id, copy_answer_next_form) {
      try {
        this.loading = true;

        let params = { id, copy_answer_next_form };

        const response = await api.put(
          "/rest-home/semiology/form/category/question",
          params
        );

        const { error, message } = response.data;

        if (!error) {
          toast(message, "success");
        } else {
          toast(message, "error");
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.error(error);
      }
    },

    async removeCategory(category_id) {
      try {
        this.loading = true;

        const params = {
          form_id: this.form.id,
          category_id,
        };
        const response = await api.delete(
          "/rest-home/semiology/form/category",
          { params }
        );
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.getCategories();
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async removeQuestion(category_id, question_id) {
      try {
        this.loading = true;

        const params = {
          form_id: this.form.id,
          category_id,
          question_id,
        };
        const response = await api.delete(
          "/rest-home/semiology/form/category/question",
          { params }
        );
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.getCategories();
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async removeAlternative(category_id, question_id, alternative_id) {
      try {
        this.loading = true;

        const params = {
          form_id: this.form.id,
          category_id,
          question_id,
          alternative_id,
        };
        const response = await api.delete(
          "/rest-home/semiology/form/category/question/alternative",
          { params }
        );
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.getCategories();
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async reorderMode() {
      this.reorder_mode = true;
      this.$emit("toggle-reorder-mode", true);
    },

    async reorderCategory(category_index, direction) {
      this.categories = arraySwapItemPosition(
        this.categories,
        category_index,
        category_index + direction
      );
    },

    async reorderQuestion(category_index, question_index, direction) {
      this.categories[category_index].questions = arraySwapItemPosition(
        this.categories[category_index].questions,
        question_index,
        question_index + direction
      );
    },

    async reorderAlternative(
      category_index,
      question_index,
      alternative_index,
      direction
    ) {
      this.categories[category_index].questions[question_index].alternatives =
        arraySwapItemPosition(
          this.categories[category_index].questions[question_index]
            .alternatives,
          alternative_index,
          alternative_index + direction
        );
    },

    async reorderCancel() {
      this.reorder_mode = false;
      this.$emit("toggle-reorder-mode", false);
      this.getCategories(false);
    },

    async reorderSave() {
      try {
        this.loading = true;

        const categories = this.categories.map((category) => ({
          category_id: category.id,
          questions: category.questions.map((question) => ({
            question_id: question.id,
            alternatives: question.alternatives.map(
              (alternative) => alternative.id
            ),
          })),
        }));
        const data = { form_id: this.form.id, categories };
        const response = await api.patch(
          "/rest-home/semilogy/form/reorder",
          data
        );
        const { error, errors, message } = response.data;
        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          await this.getCategories();
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.reorder_mode = false;
        this.loading = false;
        this.$emit("toggle-reorder-mode", false);
      }
    },

    async openModifyCategory(category_id) {
      this.current_category_id = category_id;
      this.$bvModal.show("modify_category");
    },

    async openNewQuestion(category_id) {
      this.current_category_id = category_id;
      this.$bvModal.show("new_question");
    },

    async openModifyQuestion(category_id, question_id) {
      this.current_category_id = category_id;
      this.current_question_id = question_id;
      this.$bvModal.show("modify_question");
    },

    async openModifyAlternative(category_id, question_id, alternative_id) {
      this.current_category_id = category_id;
      this.current_question_id = question_id;
      this.current_alternative_id = alternative_id;
      this.$bvModal.show("modify_alternative");
    },

    allowReorderMode() {
      if (this.categories.length > 1) return true;

      for (const category of this.categories) {
        if (category.questions === undefined) return false;
        if (category.questions.length > 1) return true;

        return category.questions.some(
          (question) => question.alternatives.length > 1
        );
      }
    },

    /**
     * Gera um HTML limpo do formulário e abre a janela de impressão do navegador.
     * Usa apenas dados já carregados em this.categories e this.form.
     * Não faz chamada de API adicional.
     */
    printForm() {
      const form = this.form;
      const categories = this.categories;

      // Data de impressão formatada em pt-BR
      const printDate = new Date().toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });

      // Monta o HTML de cada categoria e suas perguntas/alternativas
      const categoriesHtml = categories
        .map((category, catIndex) => {
          const questionsHtml = (category.questions || [])
            .map((question, qIndex) => {
              // Bloco de alternativas (só para perguntas não abertas)
              let alternativesHtml = "";
              if (
                question.type_value !== "OPEN" &&
                question.alternatives &&
                question.alternatives.length > 0
              ) {
                const items = question.alternatives
                  .map(
                    (alt) => `<li class="print-alternative">${alt.label}</li>`
                  )
                  .join("");
                alternativesHtml = `
                  <div class="print-alternatives-block">
                    <span class="print-alternatives-label">Alternativas:</span>
                    <ul class="print-alternatives-list">${items}</ul>
                  </div>`;
              }

              // Badge de obrigatoriedade
              const mandatoryBadge = question.mandatory
                ? `<span class="print-badge print-badge--required">OBRIGATÓRIA</span>`
                : "";

              // Badge do tipo de pergunta
              const typeBadge = question.type_name
                ? `<span class="print-badge print-badge--type">${question.type_name}</span>`
                : "";

              return `
              <div class="print-question">
                <div class="print-question-header">
                  <span class="print-question-number">${qIndex + 1}.</span>
                  <span class="print-question-statement">${
                    question.statement
                  }</span>
                </div>
                <div class="print-question-meta">
                  ${typeBadge}
                  ${mandatoryBadge}
                </div>
                ${alternativesHtml}
              </div>`;
            })
            .join("");

          // Badge público/privado
          const visibilityBadge =
            category.public == 1
              ? `<span class="print-badge print-badge--public">Pública</span>`
              : `<span class="print-badge print-badge--private">Privada</span>`;

          // Badge de assinatura com certificado
          const certBadge =
            category.required_certificate == 1
              ? `<span class="print-badge print-badge--cert">Assinatura com certificado</span>`
              : "";

          return `
          <div class="print-category">
            <div class="print-category-header">
              <span class="print-category-number">Categoria ${
                catIndex + 1
              }</span>
              <span class="print-category-name">${category.name.toUpperCase()}</span>
              <div class="print-category-badges">
                ${visibilityBadge}
                ${certBadge}
              </div>
            </div>
            <div class="print-questions-wrapper">
              ${
                questionsHtml ||
                '<p class="print-empty">Nenhuma pergunta cadastrada.</p>'
              }
            </div>
          </div>`;
        })
        .join("");

      // Status do formulário
      // const statusLabel = form.status_name || form.status_value || "";

      // HTML completo da janela de impressão
      // Fonte mínima 12pt para garantir legibilidade em papel (WCAG print)
      const printHtml =
        `
        <!DOCTYPE html>
        <html lang="pt-BR">
        <head>
          <meta charset="UTF-8" />
          <title>Formulário: ${form.name}</title>
          <style>
            /* Reset e base */
            *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

            body {
              font-family: Arial, Helvetica, sans-serif;
              font-size: 13pt;
              color: #1a1a1a;
              background: #fff;
              padding: 0;
              margin: 0;
            }

            /* Área de impressão */
            .print-page {
              max-width: 210mm;
              margin: 0 auto;
              padding: 20mm 18mm 20mm 18mm;
            }

            /* Cabeçalho do documento */
            .print-header {
              border-bottom: 2px solid #1f5a76;
              padding-bottom: 10px;
              margin-bottom: 20px;
            }

            .print-header-title {
              font-size: 17pt;
              font-weight: bold;
              color: #1f5a76;
              text-transform: uppercase;
              letter-spacing: 0.5px;
              display: block;
              margin-bottom: 4px;
            }

            .print-header-meta {
              font-size: 10pt;
              color: #555;
              display: flex;
              gap: 20px;
              flex-wrap: wrap;
              margin-top: 6px;
            }

            .print-header-meta span { display: inline-block; }

            /* Categoria */
            .print-category {
              margin-bottom: 24px;
            }

            .print-question {
              page-break-inside: avoid;
            }

            .print-category-header {
              background: #1f5a76;
              color: #fff;
              padding: 8px 12px;
              border-radius: 4px 4px 0 0;
              display: flex;
              align-items: baseline;
              flex-wrap: wrap;
              gap: 8px;
            }

            .print-category-number {
              font-size: 9pt;
              font-weight: normal;
              opacity: 0.85;
              white-space: nowrap;
            }

            .print-category-name {
              font-size: 13pt;
              font-weight: bold;
              letter-spacing: 0.3px;
            }

            .print-category-badges {
              margin-left: auto;
              display: flex;
              gap: 6px;
              flex-wrap: wrap;
            }

            /* Perguntas */
            .print-questions-wrapper {
              border: 1px solid #c8d8e0;
              border-top: none;
              border-radius: 0 0 4px 4px;
              padding: 4px 0;
            }

            .print-question {
              padding: 10px 14px;
              border-bottom: 1px solid #e8eef2;
            }

            .print-question:last-child { border-bottom: none; }

            .print-question-header {
              display: flex;
              gap: 6px;
              align-items: flex-start;
              margin-bottom: 5px;
            }

            .print-question-number {
              font-weight: bold;
              color: #1f5a76;
              white-space: nowrap;
              min-width: 20px;
              font-size: 12pt;
            }

            .print-question-statement {
              font-size: 12pt;
              font-weight: 600;
              color: #1a1a1a;
              line-height: 1.4;
            }

            .print-question-meta {
              display: flex;
              gap: 6px;
              flex-wrap: wrap;
              margin-left: 26px;
              margin-bottom: 6px;
            }

            /* Alternativas */
            .print-alternatives-block {
              margin-left: 26px;
              margin-top: 4px;
            }

            .print-alternatives-label {
              font-size: 9pt;
              font-weight: bold;
              color: #555;
              text-transform: uppercase;
              letter-spacing: 0.3px;
              display: block;
              margin-bottom: 4px;
            }

            .print-alternatives-list {
              list-style: none;
              padding: 0;
              margin: 0;
            }

            .print-alternative {
              font-size: 11pt;
              color: #333;
              padding: 4px 0 4px 16px;
              border-bottom: 1px dotted #ddd;
              position: relative;
            }

            .print-alternative:last-child { border-bottom: none; }

            /* Círculo para marcação manual — útil para versão impressa */
            .print-alternative::before {
              content: "";
              display: inline-block;
              width: 11px;
              height: 11px;
              border: 1.5px solid #555;
              border-radius: 50%;
              position: absolute;
              left: 0;
              top: 6px;
            }

            /* Badges */
            .print-badge {
              display: inline-block;
              font-size: 8pt;
              font-weight: bold;
              padding: 2px 7px;
              border-radius: 10px;
              text-transform: uppercase;
              letter-spacing: 0.3px;
              white-space: nowrap;
            }

            .print-badge--public   { background: #d4edda; color: #155724; }
            .print-badge--private  { background: #f8d7da; color: #721c24; }
            .print-badge--cert     { background: #fff3cd; color: #856404; }
            .print-badge--required { background: #f8d7da; color: #721c24; }
            .print-badge--type     { background: #d1ecf1; color: #0c5460; border: 1px solid #bee5eb; }

            /* Vazio */
            .print-empty {
              padding: 12px 14px;
              font-size: 10pt;
              color: #888;
              font-style: italic;
            }

            /* Rodapé */
            .print-footer {
              margin-top: 32px;
              padding-top: 10px;
              border-top: 1px solid #ccc;
              font-size: 9pt;
              color: #888;
              display: flex;
              justify-content: space-between;
              flex-wrap: wrap;
              gap: 4px;
            }

            /* Configurações de página para impressão */
            @page {
              size: A4;
              margin: 15mm;
            }

            @media print {
              body { padding: 0; }
              .print-page { padding: 0; max-width: 100%; }
              .print-question { page-break-inside: avoid; }
            }
          </style>
        </head>
        <body>
          <div class="print-page">

            <div class="print-header">
              <span class="print-header-title">${form.name}</span>
              ${
                form.description
                  ? `<p style="font-size:10.5pt; color:#444; margin-top:4px;">${form.description}</p>`
                  : ""
              }
              <div class="print-header-meta">
                <span><strong>Impresso em:</strong> ${printDate}</span>
                <span><strong>Total de categorias:</strong> ${
                  categories.length
                }</span>
              </div>
            </div>

            ${
              categories.length > 0
                ? categoriesHtml
                : '<p style="color:#888; font-style:italic;">Nenhuma categoria cadastrada.</p>'
            }

            <div class="print-footer">
              <span>Formulário: ${form.name}</span>
              <span>Impresso em: ${printDate}</span>
            </div>

          </div>

          <` +
        `script>window.onload = function () { window.print(); };</` +
        `script>
        </body>
        </html>`;

      // Abre janela dedicada — evita imprimir a navbar e botões da aplicação
      const printWindow = window.open("", "_blank", "width=900,height=700");
      if (!printWindow) {
        alert(
          "Seu navegador bloqueou a janela de impressão. Permita pop-ups para este site."
        );
        return;
      }
      printWindow.document.open();
      printWindow.document.write(printHtml);
      printWindow.document.close();
    },
  },
};
</script>

<style scoped>
.switch-modern {
  position: relative;
  display: inline-block;
  width: 64px;
  height: 34px;
  cursor: pointer;
}

.switch-modern input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider-modern {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #cbd5e1;
  border-radius: 34px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  padding: 2px;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
}

.slider-thumb {
  width: 30px;
  height: 30px;
  background: white;
  border-radius: 50%;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  transform: translateX(0);
}

.switch-modern input:checked + .slider-modern {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.switch-modern input:checked + .slider-modern .slider-thumb {
  transform: translateX(30px);
}

.switch-modern input:checked + .slider-modern .thumb-icon {
  color: #10b981;
}

.switch-modern input:disabled + .slider-modern {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>